/**************************************************************************************************************
    For a list of available material design icons, see: https://fonts.google.com/icons?selected=Material+Icons

    Usage: <vetology-svg
        data-svg="<name of svg, as given in the svg array below>"
        data-width="<width>"  // sets the width of the svg element
        data-height="<height>"  // sets the height of the svg element
        data-size="100"  // sets the size of the svg
        data-color="<color>"  // sets the color of the svg, can be hex or named color
        data-viewbox="x y dx dy">  // sets the viewbox attribute of the svg element
    </vetology-svg>

    Example: <vetology-svg data-svg="species_canine" data-size="100"></vetology-svg>

    Note: The data-path attribute is required.  The data-size attribute is required if you want to see the svg.

    Edit this file to include the icons you want to use.  The icons are stored in the svg object/array.  The key
    is the data-svg attribute value that you will use in your <vetology-svg> element.  The value is the svg Name that you imported.  The svg file is fetched from the path.  The svg file is then parsed and the svg element is created.  The svg element is then appended to this element.  This element is then removed from the DOM.

**************************************************************************************************************/
import SpeciesAvian from '../../../../images/svg/species/Avian.svg';
import SpeciesAvianFull from '../../../../images/svg/species/Avian_full.svg';
import SpeciesCanine from '../../../../images/svg/species/Canine.svg';
import SpeciesCanineFull from '../../../../images/svg/species/Canine_full.svg';
import SpeciesEquine from '../../../../images/svg/species/Equine.svg';
import SpeciesEquineFull from '../../../../images/svg/species/Equine_full.svg';
import SpeciesExotic from '../../../../images/svg/species/Exotics.svg';
import SpeciesExoticFull from '../../../../images/svg/species/Exotics_full.svg';
import SpeciesFeline from '../../../../images/svg/species/Feline.svg';
import SpeciesFelineFull from '../../../../images/svg/species/Feline_full.svg';


const svgs = {
    'species_canine': SpeciesCanine,
    'species_canine_full': SpeciesCanineFull,
    'species_feline': SpeciesFeline,
    'species_feline_full': SpeciesFelineFull,
    'species_equine': SpeciesEquine,
    'species_equine_full': SpeciesEquineFull,
    'species_avian': SpeciesAvian,
    'species_avian_full': SpeciesAvianFull,
    'species_exotic': SpeciesExotic,
    'species_exotic_full': SpeciesExoticFull
}


export class VetologySvg extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        this.init();
    }

    init() {
        this.createPath();
    }

    createPath() {
        if (this.dataset.svg === undefined) {
            console.error('VetologySvg: Missing data-path attribute');
            throw new Error('VetologySvg: Missing data-path attribute');
        }

        const path = svgs[this.dataset.svg];
        fetch(path) // Get the contents of the SVG file
            .then(response => response.text())
            .then(svgData => {
                const svgContainer = document.createElement('div');
                svgContainer.innerHTML = svgData;
                const svgElem = svgContainer.querySelector('svg');

                // got our svg element.  Stet the children and attributes with those of this element
                while (this.firstChild) {
                    const child = this.firstChild;
                    const svgChild = document.createElementNS('http://www.w3.org/2000/svg', child.tagName);
                    svgElem.appendChild(svgChild);
                    svgChild.outerHTML = child.outerHTML;
                    this.removeChild(child);
                }

                for (let i = 0; i < this.attributes.length; i++) {
                    const attr = this.attributes[i];
                    if (attr.name === 'viewbox') {
                        svgElem.setAttributeNS('viewBox', attr.value);
                    } else {
                        svgElem.attributes.setNamedItem(attr.cloneNode());
                    }
                }

                // apply styles
                for (let i = this.style.length - 1; i >= 0; i--) {
                    const style = this.style[i];
                    svgElem.style[style] = this.style[style];

                }

                // now replace this with our new svg element
                this.parentNode.replaceChild(svgElem, this);
            });

    }
}

customElements.define('vetology-svg', VetologySvg);